import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MapService } from '../_services/map.service';
import { Vehicle } from '../_models/vehicle';

@Component({
  selector: 'app-vehicleRoutes',
  templateUrl: './vehicleRoutes.component.html',
  styleUrls: ['./vehicleRoutes.component.css']
})
export class VehicleRoutesComponent implements OnInit {
  date = new Date();
  dateForm: UntypedFormGroup;
  vehicles: Vehicle[];
  

  constructor(private mapService: MapService) { }

  ngOnInit() {
    this.mapService.getVehicles(this.date).subscribe(data => {
      this.vehicles = data;
    });
    this.dateForm = new UntypedFormGroup({
      date: new UntypedFormControl(this.date),
    });
  }

  loadData() {
    var selectedDate = this.dateForm.get('date').value;
    this.date = selectedDate;
    this.date.setHours(0, 0, 0, 0);
    this.mapService.getVehicles(this.date).subscribe(data => {
      this.vehicles = data;
    });
  }

}
